import React from "react";
import {
    CombinedEquipmentRequestEntity,
    EquipmentRequestEntity,
    useUpdateCombinedEquipmentRequestMutation
} from "graphql/graphQlApiHooks";
import {useDialog} from "providers/DialogProvider";
import {
    DeleteSingleRequestFromCombineRequestDialog
} from "../../components/Dialogs/DeleteSingleRequestFromCombineRequestDialog";
import { useSnackbar } from "notistack";

export const useDeleteSingleRequestFromCombineRequestAction = () => {
    const [dialog, closeDialog] = useDialog();
    const { enqueueSnackbar } = useSnackbar();


    const [updateCombinedEquipmentRequest, {loading}] = useUpdateCombinedEquipmentRequestMutation({
        refetchQueries: ['getEquipmentRequests']
    });


    const handleDeleteSingleRequestFromCombineRequest = (singleRequest: EquipmentRequestEntity, requests?: CombinedEquipmentRequestEntity[]) => {
        const parentCombinedRequest = requests?.find(item => item.id === singleRequest.parentCombinedRequestId)
        dialog({
            onClose: closeDialog,
            title: "Удаление заявки из объединённой заявки",
            maxWidth: "xs",
            fullWidth: true,
            children: <>
                <DeleteSingleRequestFromCombineRequestDialog
                    singleRequest={singleRequest}
                    combinedRequest={parentCombinedRequest || singleRequest?.parentCombinedRequest}
                    onClose={() => closeDialog()}
                    onDelete={() => {
                        closeDialog()
                        if (parentCombinedRequest && singleRequest?.parentCombinedRequestId) {
                          
                            
                            updateCombinedEquipmentRequest({
                                variables: {
                                    input: {
                                        id: singleRequest.parentCombinedRequestId,
                                        childRequestId: parentCombinedRequest.childRequests?.map(item => item.id).filter(item => item !== singleRequest.id) || []
                                    }
                                }
                            })
                            .then((result) => {
                                enqueueSnackbar('Заявка успешно удалена из объединенной заявки', { variant: 'success' });
                            })
                            .catch((error) => {
                                enqueueSnackbar(
                                    `Ошибка при удалении заявки: ${error.message || 'Неизвестная ошибка'}`,
                                    { variant: 'error' }
                                );
                            });
                        } else {
                            console.error('Не удалось найти родительскую объединенную заявку или ID:', {
                                parentCombinedRequest,
                                parentCombinedRequestId: singleRequest?.parentCombinedRequestId
                            });
                            enqueueSnackbar('Ошибка: не удалось найти объединенную заявку', { variant: 'error' });
                        }
                    }}
                />
            </>
        });


    };

    return {
        handleDeleteSingleRequestFromCombineRequest
    }
};